import {
  AfterViewInit,
  Component,
  ElementRef,
  Input,
  ViewChild
} from '@angular/core';
import { IonicSlides, ModalController } from '@ionic/angular';
import { Swiper } from 'swiper';
import { SwiperContainer } from 'swiper/element/bundle';

@Component({
  selector: 'app-modal-preface-steps',
  templateUrl: './modal-preface-steps.component.html',
  styleUrls: ['./modal-preface-steps.component.scss'],
  standalone: false
})
export class ModalPrefaceStepsComponent implements AfterViewInit {
  readonly swiperModules = [IonicSlides];

  @ViewChild('swiper') swiper: ElementRef<SwiperContainer> | undefined;

  /**
   * lista di step
   */
  @Input() steps: {
    figure?: string;
    message: string;
  }[] = [];

  /**
   * suggerimento per l'avvio degli step
   */
  @Input() startTip: string;

  /**
   * suggerimento per la conlusione degli step
   */
  @Input() endTip: string;

  /**
   * index step visualizzato
   */
  activeIndex = 0;

  /**
   * flag per renderizzare il componente slide
   */
  slidesVisible = false;

  /**
   * getter per determinare se gli step sono completi
   */
  get completed(): boolean {
    return this.activeIndex >= this.steps.length - 1;
  }

  constructor(private modalController: ModalController) {}

  ngAfterViewInit(): void {
    this.initSwiper();
    this.setActiveIndex();
  }

  /**
   * evento al cambio slide
   */
  onSlideWillChange(): void {
    this.setActiveIndex();
  }

  /**
   * naviga allo step successivo
   */
  toNextStep(): void {
    this.toStep(this.activeIndex + 1);
  }

  /**
   * naviga allo step precedente
   */
  toPrevStep(): void {
    this.toStep(this.activeIndex - 1);
  }

  /**
   * naviga allo step richiesto
   */
  toStep(index: number): void {
    if (index < 0 || index > this.steps.length - 1) {
      this.close();
    } else {
      this.swiperSlideTo(index);
    }
  }

  /**
   * chiude modale
   */
  private async close(): Promise<void> {
    await this.modalController.dismiss();
  }

  /**
   * imposta l'index attivo
   */
  private setActiveIndex(): void {
    this.activeIndex = this.getSwiperActiveIndex();
  }

  /**
   * inizializza lo swiper
   */
  private initSwiper(): void {
    if (this.getSwiper()) {
      this.getSwiper().init();
    }
  }

  /**
   * restituisce l'index della slide attiva
   */
  private getSwiperActiveIndex(): number {
    if (this.getSwiper()) {
      return this.getSwiper().activeIndex;
    } else {
      return 0;
    }
  }

  /**
   * va alla slide numero
   */
  private swiperSlideTo(index: number): void {
    if (this.getSwiper()) {
      this.getSwiper().slideTo(index);
    }
  }

  /**
   * restituisce istanza swiper
   */
  private getSwiper(): Swiper | undefined {
    return this.swiper?.nativeElement?.swiper;
  }
}
